import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ArticleCard from "../components/ArticleCard";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";

const CATEGORIES = ["all", "finance", "politique", "socio-culturel", "interview", "top"];

export default function Articles() {
  const { t } = useI18n();
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "all";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const qs = cat && cat !== "all" ? `?category=${cat}` : "";
    api.get(`/articles${qs}`).then((r) => setItems(r.data || [])).finally(() => setLoading(false));
  }, [cat]);

  const setCat = (c) => {
    if (c === "all") setParams({});
    else setParams({ cat: c });
  };

  return (
    <div className="max-w-[1320px] mx-auto px-6 lg:px-10 pt-16 pb-24" data-testid="page-articles">
      <div className="overline mb-3">{t("home.overline")}</div>
      <h1 className="serif text-5xl md:text-7xl leading-none">{t("articles.title")}</h1>
      <p className="mt-4 max-w-xl text-lg text-[var(--gai-grey-700)]">{t("articles.sub")}</p>

      <div className="gai-hairline my-10" />

      <div className="flex flex-wrap gap-2 mb-10" data-testid="articles-filters">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            className={`px-4 py-2 text-[0.72rem] tracking-[0.2em] uppercase border transition ${
              c === cat
                ? "border-[var(--gai-red)] text-[var(--gai-black)] bg-[var(--gai-red)]"
                : "border-[var(--gai-grey-200)] text-[var(--gai-black)] hover:border-[var(--gai-red)]"
            }`}
            data-testid={`filter-${c}`}
          >
            {t(`articles.cats.${c}`)}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-[var(--gai-grey-600)]">{t("common.loading")}</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-[var(--gai-grey-200)]">
          {items.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      )}
    </div>
  );
}
